import clsx from 'clsx';
import styles from '../Select.module.css';
import scrollbarStyles from '../../../styles/scrollbarThin.module.css';
import { getMenuScrollLayout } from '../lib/multiSelectMenuMetrics';

export function SelectMenu({
  listboxId,
  ariaLabel,
  menuPlacement,
  menuClassName = '',
  optionClassName = '',
  optionSelectedClassName = '',
  optionHighlightedClassName = '',
  optionLabelClassName = '',
  optionSpacerClassName = '',
  options,
  value,
  highlightedIndex,
  setHighlightedIndex,
  commitChange,
  maxMenuRows,
}) {
  const { needsMenuScroll, menuMaxHeightPx } = getMenuScrollLayout(maxMenuRows, options.length);
  const menuStyle =
    needsMenuScroll && menuMaxHeightPx != null ? { maxHeight: `${menuMaxHeightPx}px` } : undefined;

  return (
    <ul
      id={listboxId}
      role="listbox"
      className={clsx(
        styles.menu,
        menuPlacement === 'top' && styles.menuTop,
        menuClassName,
        needsMenuScroll && scrollbarStyles.scrollbarThinY,
        needsMenuScroll && scrollbarStyles.overscrollContain,
      )}
      aria-label={ariaLabel}
      style={menuStyle}
    >
      {options.map((opt, index) => {
        const isSelected = opt.value === value;
        const isHighlighted = index === highlightedIndex;
        return (
          <li
            key={String(opt.value)}
            role="option"
            aria-selected={isSelected}
            className={clsx(
              styles.option,
              optionClassName,
              isSelected && styles.optionSelected,
              isSelected && optionSelectedClassName,
              isHighlighted && styles.optionHighlighted,
              isHighlighted && optionHighlightedClassName,
            )}
            onMouseEnter={() => setHighlightedIndex(index)}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => {
              if (opt.disabled) return;
              commitChange(opt.value);
            }}
          >
            <span className={clsx(styles.optionLabel, optionLabelClassName)}>{opt.label}</span>
            <span className={clsx(styles.optionSpacer, optionSpacerClassName)} aria-hidden />
          </li>
        );
      })}
    </ul>
  );
}
